import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRollbar } from '@rollbar/react'

import Loading from '../components/psc/lib/Loading'

import useAuthentication from '../hooks/useAuthentication';
import useBrowserTabTitle from '../hooks/useBrowserTabTitle';

const SharePointCallback = () => {
  useBrowserTabTitle('SharePoint')

  const location = useLocation()
  const navigate = useNavigate()
  const rollbar = useRollbar();

  const { currentUser } = useAuthentication();
  
  const [oauthError, setOauthError] = useState(null)
  const errorMap = {
    access_denied: "User clicked Cancel",
    interaction_required: "User must re-authenticate or consent",
    login_required: "Silent login failed, interactive login required",
    consent_required: "Admin or user consent missing",
    user_cancelled: "User explicitly aborted login",
    authentication_canceled: "Browser window closed mid-flow"
  }
  const extraMap = {
    consent_required: "Please try again once your IT Admin has approved your authentication request.",
  }
  
  useEffect(() => {
    const query = new URLSearchParams(location.search)
    const code = query.get('code')
    const state = query.get('state')
    const error = query.get('error')
    const errorDescription = query.get("error_description")
    if (error && error !== "") {
      setOauthError(error)
      rollbar?.error?.("Error authenticating with SharePoint, error " + error, error, {
        currentUserId: currentUser?.id,
        error: error,
        errorDescription: errorDescription,
      })
      return
    }
    
    const url = "/v0/sharepoint/token/callback?code="+code+"&state="+state
    fetch(url, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) throw response
        return response.json()
      })
      .then(function(json) {
        if (json.is_error) {
          setOauthError(json.message)
          return
        }
        navigate(json.redirect_url)
      })
      .catch(error => console.log("OAuth callback error", error))
    
  }, [])

  if (oauthError && oauthError !== "") {
    const message = errorMap[oauthError] ? errorMap[oauthError] : oauthError
    const extra = extraMap[oauthError] ? extraMap[oauthError] : ""
    return (
      <div className="wrapper wrapper-content">
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox float-e-margins">
              <div className="ibox-title">
                <h2>
                  Error Authenticating with SharePoint
                </h2>
              </div>
              <div className="ibox-content">
                <p>
                  We encountered an error when trying to authenticate you with SharePoint.
                </p>
                <p>
                  The error: <strong>{message}</strong>
                </p>
                <p>
                  {extra}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  
  return <Loading />
};

export default SharePointCallback
